module.exports = __webpack_public_path__ + "static/img/YIX.b4601114.png";